import { useCallback, useContext, useState } from 'react';
import MenuOption from '~/constants/MenuOption';
import AppliedFiltersContext from '~/contexts/AppliedFiltersContext';
import FacetDataContext from '~/contexts/FacetDataContext';
import Checkbox from './Checkbox';
import FilterDrawer from './FilterDrawer';
import LabelWithCount from './LabelWithCount';
import { CommonWrapper } from './styles';
import type WithClassName from './WithClassName';
import WithExpandOnOpen from './WithExpandOnOpen';

const generateId = (name: string) => name.replace(/\s/g, '').toLowerCase();

const nameMapping = {
  Minivan: { imageName: 'mini-van' },
  Truck: { imageName: 'truck' },
  SUV: { imageName: 'suv' }
};

function getImageUrl(displayName: string) {
  const imageName = nameMapping[displayName]?.imageName ?? displayName;

  return `${
    process.env.CVNA_APP_ASSETS_CDN
  }/search-assets/body-styles/${imageName.toLowerCase()}.png`;
}

type LabelProps = {
  count: number;
  displayName: string;
};

const Label = ({ count, displayName }: LabelProps) => (
  <div className="flex items-center justify-between py-2">
    <LabelWithCount count={count} displayName={displayName} />
    <img
      src={`${getImageUrl(displayName)}?width=80&trim=32,0,0,0`}
      alt={displayName}
      style={{ transform: 'rotateY(180deg)' }}
    />
  </div>
);

type OwnProps = WithClassName & WithExpandOnOpen;

function BodyType({ className, expandOnOpen }: OwnProps) {
  const { facetData } = useContext(FacetDataContext);
  const { appliedFilters, updateListFilter } = useContext(
    AppliedFiltersContext
  );
  const expandSection = expandOnOpen === MenuOption.Body;
  const [show, setShow] = useState(expandSection);

  return (
    <FilterDrawer
      className={className}
      dataQa="facet-body-style"
      facetContent={facetData?.bodyStyles?.buckets}
      facetName="Body Type"
      show={show}
      onToggle={useCallback(() => setShow(v => !v), [])}
      expandOnOpen={expandSection}
    >
      <CommonWrapper>
        {facetData?.bodyStyles?.buckets.map(({ count, displayName, key }) => (
          <Checkbox
            checked={Boolean(appliedFilters.bodyStyles?.includes(key))}
            className="w-full"
            facet="bodyStyle"
            filter={displayName}
            id={`body-type-${generateId(displayName)}`}
            key={displayName}
            label={<Label displayName={displayName} count={count} />}
            onChange={() =>
              updateListFilter({
                filterKey: 'bodyStyles',
                value: key
              })
            }
          />
        ))}
      </CommonWrapper>
    </FilterDrawer>
  );
}

export default BodyType;
